<template>
    <info-text-editor
      textKey="pvp_rules"
      title="PvP Rules"
      viewPermission="PvpRulesView"
      editPermission="PvpRulesEdit"
    />
</template>

<script>
import InfoTextEditor from './InfoTextEditor.vue'

export default {
  name: 'PvpRules',
  components: {
    InfoTextEditor
  }
}
</script>
